<script setup>
  import { computed, ref } from 'vue';
  import Modal from './Modal.vue'

  const props = defineProps({
    file: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    hideDownload: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['close']);

  const fileType = computed(() => {
    const mimeType = props.file.mime_type || '';
    if (mimeType.includes('image')) {
      return 'Image';
    } else if (mimeType.includes('video')) {
      return 'Video';
    } else if (mimeType.includes('doc')) {
      return 'Word Document';
    } else if (mimeType.includes('text')) {
      return 'Text File';
    } else if (mimeType.includes('pdf')) {
      return 'PDF';
    } else {
      return 'File';
    }
  });

</script>




<template>
  <Modal
    :show="show"
    :closeable="true"
    @close="emit('close')"
  >
    <div class="p-4">
      <h2 class="text-lg font-semibold mb-4">{{ file.name }}</h2>
      <div class="flex justify-center">
        <img
          v-if="fileType === 'Image' || fileType === 'PDF'"
          :src="fileType === 'Image' ? file.url : file.thumbnail"
          alt="Media Preview"
          class="max-w-full max-h-96 object-contain"
        />
        <video
          v-else-if="fileType === 'Video'"
          :src="file.url"
          controls
          autoplay
          class="max-w-full max-h-96"
        ></video>
        <div
          v-else
          class="flex items-center justify-center w-full h-96 bg-gray-200 text-gray-600"
        >
          <span class="text-center">Preview not available for this file type</span>
        </div>

      </div>
      <div class="mt-4">
        <p><strong>File Type:</strong> {{ fileType }}</p>
        <a
          v-if="!hideDownload"
          :href="file.url"
          class="text-blue-600 hover:underline"
          download
        >
          <p><strong>Download Here</strong></p>
        </a>
      </div>
    </div>
  </Modal>
</template>
